import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import Loading from "@/client/modules/orcamentos/loading";
import { OrcamentosClient } from "@/client/modules/orcamentos/orcamentos-client";

type Search = { todos?: string };

export const Route = createFileRoute("/app/orcamentos/")({
  validateSearch: (s: Record<string, unknown>): Search => ({ todos: s.todos as string | undefined }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("orcamentos", "page", deps)),
  head: () => pageHead("Orçamentos"),
  pendingComponent: Loading,
  component: OrcamentosPage,
});

function OrcamentosPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("orcamentos", "page", search);
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Orçamentos" description="Propostas de procedimentos, do rascunho até a conclusão." />
      <OrcamentosClient {...data} />
    </div>
  );
}
